import {Injectable, inject} from '@angular/core';
import Pusher from 'pusher-js';
import {catchError, first} from 'rxjs/operators';
import {PusherJsApiService} from './pusher-js-api.service';
import {throwError} from 'rxjs';
import {SessionStorageService} from '@core/services';

@Injectable({
  providedIn: 'root'
})
export class PusherJsService {
  private readonly _pusherApiService = inject(PusherJsApiService);
  private readonly _sessionStorage = inject(SessionStorageService);

  pusher!: Pusher;
  briefSubscribe;
  storageKey: string = `pusher-${this._pusherApiService.activeCompany}` as const;
  storage: {key: string; cluster: string} = JSON.parse(this._sessionStorage.get(this.storageKey)) || {};

  init() {
    if (Object.keys(this.storage).length > 0) {
      const {key, cluster} = this.storage;
      this.pusher = new Pusher(key, {cluster});
      return;
    }

    this._pusherApiService
      .getBroadcastSettings()
      .pipe(
        first(),
        catchError(() => throwError(() => 'Pusher-js lib is not initialized!'))
      )
      .subscribe(({key, cluster}) => {
        this._sessionStorage.set(this.storageKey, JSON.stringify({key, cluster}));
        this.pusher = new Pusher(key, {cluster});
      });
  }

  unsubscribe(channels: string[]) {
    channels.forEach(channel => this.pusher.unsubscribe(channel));
  }
}
